module.exports = __webpack_public_path__ + "static/media/logo.8c8a1218.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/logo.svg
// module id = 80
// module chunks = 0